/**
 * True in the hidden iframe MSAL opens to renew a token: a framed copy of the
 * console whose address carries Microsoft's sign-in answer (code or error, and
 * state, in the fragment or the query). MSAL 5 waits for that frame to post the
 * answer back to the console tab (its redirect bridge); the frame must do only
 * that and never start the console.
 */
export function isMsalResponseFrame(win) {
  let framed
  try {
    framed = win.self !== win.top
  } catch {
    framed = true // a cross-origin parent: still a frame
  }
  if (!framed) return false
  const params = new URLSearchParams(`${win.location.hash.replace(/^#/, '')}&${win.location.search.replace(/^\?/, '')}`)
  return params.has('state') && (params.has('code') || params.has('error'))
}
